import { render, staticRenderFns } from "./SnsForm.vue?vue&type=template&id=d75e4b50&scoped=true&"
import script from "./SnsForm.vue?vue&type=script&lang=js&"
export * from "./SnsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d75e4b50",
  null
  
)

export default component.exports